import React, { useEffect, useState } from 'react';
import './EventsOverviewPage.css';
import { motion } from 'framer-motion';
import { backdropTransition, transitionDuration } from '../../../../../Util/PageTransitions';
import { Link, withRouter, useHistory } from 'react-router-dom';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import Popup from 'reactjs-popup';
import { BACK_DROP_FALSE } from "../../../../../Util/helper";
import axiosApi from "../../../../../core/interceptor/interceptor";
import { config } from '../../../../../config';
import moment from 'moment';
import close from "../../../../../assets/close.svg";
import add from "../../../../../assets/add-icon.svg";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const renderEvent = (eventInfo) => {
	return (
		<>
			<small>{eventInfo.event._def.extendedProps.name}</small>
			<br />
			<small>{moment(eventInfo.event._def.extendedProps.start_time, 'HH:mm').format('hh:mm A')}</small>
			<small> - </small>
			<small>{moment(eventInfo.event._def.extendedProps.end_time, 'HH:mm').format('hh:mm A')}</small>
		</>
	)
}

function Dialog(props) {
	const [data, setData] = useState(null);
	const [deleteDialog, setDeleteDialog] = useState(false);

	useEffect(() => {
		setData(props.eventData);
		//eslint-disable-next-line
	}, []);

	const handleDeleteConfirmation = () => {
		setDeleteDialog(true);
	}
	const handleDelete = () => {
		axiosApi.delete(`${config.apiUrl}/events/${data.event_id}`)
			.then(res => {
				props.eventDeleteion(true);
			}).catch(() => {
			})
	}
	return (data &&
		<div className="modal eventDetail-popup">
			<div className="modal-header">
				<h2>{deleteDialog ? 'Warning' : 'Event Details'}</h2>
				<span className="close" onClick={!deleteDialog ? props.closePopup : () => setDeleteDialog(false)} >
					<img src={close} alt='close-icon'/>
				</span>
			</div>
			{!deleteDialog ?
				<div className="modal-body">
					<div className="inner-blk">
						<span className="label">Event Name:</span>
						<span className="value">{data.name}</span>
					</div>
					<div className="inner-blk">
						<span className="label">Event Start Time:</span>
						<span className="value">{moment(data.start_time, 'HH:mm').format('hh:mm A')}</span>
					</div>
					<div className="inner-blk">
						<span className="label">Event End Time:</span>
						<span className="value">{moment(data.end_time, 'HH:mm').format('hh:mm A')}</span>
					</div>
					<div className="inner-blk">
						<span className="label">Event Description:</span>
						<span className="value" dangerouslySetInnerHTML={{
							__html: data.description,
						}}></span>
					</div>
				</div>
				:
				<div className='modal-body delete-popup'>
					<FontAwesomeIcon icon={faExclamationTriangle} className='warning-icon' />
					<p>Are you sure you want to delete?</p>
				</div>
			}
			<div className="modal-footer">
				<button className="primary-btn cancel-btn" onClick={!deleteDialog ? handleDeleteConfirmation : () => setDeleteDialog(false)}>{deleteDialog ? 'Cancel' : 'Delete Event'}</button>
				{!deleteDialog ?
					<Link to={
						{
							pathname: `/admin/events/create/${data.event_id}`,
							id: data.event_id,
						}
					}>
						<button className='primary-btn'>Edit Event</button>
					</Link>
					:
					<button className='primary-btn' onClick={handleDelete}>Confirm</button>
				}
			</div>
		</div>
	)
}

function EventsOverviewPage(props) {
	const [state, setState] = useState({
		createEvent: false,
		event_date: new Date(),
		event: [],
		showPopup: false,
		selectedEvent: null,
	});

	function getEvents() {
		axiosApi.get(`${config.apiUrl}/events`)
			.then((res) => {
				if (res && res.data && res.data.data) {
					setState((prev) => ({
						...prev,
						event: res.data.data,
					}));
				}
			})
			.catch((err) => {
				console.error(err);
			})
	}

	useEffect(() => {
		getEvents();
	}, []);

	const getEventsAfterDeleteion = (isDelete) => {
		if (isDelete === true) {
			getEvents();
			setState({
				showPopup: false,
			})
			isDelete = false;
		}
	}

	const history = useHistory();

	function togglePopup() {
		setState((prev) => ({
			...prev,
			showPopup: false,
			selectedEvent: null,
		}));
	}

	const handleEventClick = (eventDetails) => {
		setState((prev) => ({
			...prev,
			showPopup: true,
			selectedEvent: eventDetails.event._def.extendedProps
		}))
	}

	return (
		<motion.div className='' initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }}>
			<div className='adminEventsCalendarWrapper content-wrapper users-wrapper'>
				<div className='heading-wrapper'>
					<Link to="/admin/events/create">
						<button className='btn primary-btn'><img src={add} alt='add-icon' />Create Event</button>
					</Link>

				</div>
				<FullCalendar
					plugins={[dayGridPlugin, interactionPlugin]}
					initialView="dayGridMonth"
					dateClick={(e) => {
						history.push('events/create', { date: e.date });
					}}
					visibleRange={{
						start: new Date(),
						end: '2025-03-25'
					}}
					events={state.event}
					eventContent={renderEvent}
					eventClick={handleEventClick}
				/>
			</div>
			<Popup open={state.showPopup} closeOnDocumentClick={BACK_DROP_FALSE}>
				<Dialog
					closePopup={togglePopup}
					eventData={state.selectedEvent}
					eventDeleteion={getEventsAfterDeleteion}
				/>
			</Popup>
		</motion.div>
	);
}

export default withRouter(EventsOverviewPage);

